/* eslint-disable @typescript-eslint/naming-convention */
import React from 'react';
import BodyClassName from 'react-body-classname';
import { useSelector } from 'react-redux';

import { CMSNavigation, CMSReferences } from '@swf/cms';
import { select } from '@swf/core/store';

import styles from './NotFound.scss';
import NotFoundBody from './NotFoundBody';

const NotFound: React.FC = () => {
  const website = useSelector(select.cms.getWebsite);
  const { menu, depth } = useSelector(select.cms.getMenu);
  const isEmbedded = useSelector(select.device.isEmbedded);
  const embeddedRoute = useSelector(select.location.isEmbeddedRoute);
  const showWebContent = !(isEmbedded || embeddedRoute);

  return (
    <>
      <BodyClassName className={styles.body} />
      {showWebContent && <CMSReferences references={website?.site_header} />}
      {menu ? <CMSNavigation menu={menu} maxDepth={depth || 1} /> : null}
      <NotFoundBody />
      {showWebContent && <CMSReferences references={website?.site_footer} />}
    </>
  );
};

export default NotFound;
